import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from "react-bootstrap"
// import { Form, Button, Card, InputGroup } from 'react-bootstrap';
// import { useForm } from "react-hook-form";
// import { FaUser, FaEye, FaEyeSlash } from 'react-icons/fa';
import "./Login.css"
// import loginImg from "../../assets/images/login.png"
// import TRLogo from "../../assets/images/TR-logo.png"
import { useNavigate, useSearchParams } from "react-router-dom";
import API from "../../services/axiosInstance";
import { jwtDecode } from 'jwt-decode';
import { useAuth } from '../security/authContext.js';
import { FormLoader, useFormLoader } from '../common_modules/loader.js';

const ViewDashboard = () => {
    // const [showPassword, setShowPassword] = useState(false);
    // const { register, handleSubmit, formState: { errors }, } = useForm();
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook

    // hooks
    const navigate = useNavigate();
    const { login } = useAuth();
    const [searchParams] = useSearchParams();
    const name = searchParams.get("name");
    const parentToken = searchParams.get("t");

    const getViewDashboardToken = async () => {
        startLoading();
        try {
            // const response = await API.post(`/auth/private/view/dashboard/${name}`);
            const response = await API.post(`/auth/private/view/dashboard/${name}`,
                {}, // request body
                {
                    customToken: parentToken,
                }
            );
            const token = response?.data?.data;
            if (token) {
                // decode token details
                const decoded = jwtDecode(token);
                localStorage.setItem("token", token);
                localStorage.setItem("username", decoded.sub);

                if (decoded.userId && decoded.accountType == 1) {
                    // set accounts details from api
                    const response = await API.get(`/publisher/accounts/userid/${decoded.userId}`);
                    if (response.status === 200) {
                        const data = response.data.data;
                        // set some information into session 
                        localStorage.setItem("language", data.languageType);
                        localStorage.setItem("userId", data.id);
                        localStorage.setItem("userGuid", data.userGuid);
                    }
                }


                setTimeout(() => {
                    // context login details for set permission for context after login
                    stopLoading();
                    login(navigate);
                }, 3500);
            }
        } catch (err) {
            console.error(err);
        } finally { }
    };

    useEffect(() => {
        getViewDashboardToken();
    }, []);

    return (
        <FormLoader isLoading={isLoading} text={`Authenticating… ${name}`}></FormLoader>
    )
}
export default ViewDashboard;